module.exports = __webpack_public_path__ + "images/organization/red-face.2861547542157c546553.svg";